import React, { useEffect, useState } from 'react'
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPaperPlane, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import { userloginDetails } from '../Utils/AdminAuth';
import { HOST_URL, NODE_HOST_URL, NODE_HOST_URL_v1 } from '../Dashboard/api/Api';
import Axios from '../../axios/Axios';
import DeleteModal from '../Dashboard/campaign/Rcs/DeleteModal';

const EntityChainManagement = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const adminType = lStorage.user.isAdmin;

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: "pointer",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (style) => ({
            ...style,
            fontSize: "12px",
        }),
    };

    const [selectedUser, setSelectedUser] = useState('');
    const [allUsers, setAllUsers] = useState([]);
    const [searchList, setSearchList] = useState('')
    const [chainDataList, setChainDataList] = useState([])
    const [usersId, setUsersId] = useState('')
    const [active, setActive] = useState(true)
    const [entityId, setEntityID] = useState('')
    const [deleteModal, setDeleteModal] = useState(false);
    const [chainentityid, setChainEntityid] = useState("");
    const [chainid, setChainid] = useState("")
    const [dataItem, setDataItem] = useState({
        deliverFunctions: '',
        chainUsers: '',
        chainValues: ''
    })
    const [error, setError] = useState({
        status: false,
        bgColor: "",
        errorMessage: ""
    })

    useEffect(() => {
        getUserList();
        MappingList();
    }, [])

    const getUserList = async () => {
        try {
            const payload = {
                user_id: userId,
                method: "retrieve_all_user",
                type: adminType,
                token: userToken
            };

            let { data } = await Axios.post(`${HOST_URL}/admin_user_list.php`, payload);

            if (data.success) {
                const formattedUsers = data.data.map(user => ({
                    value: user.id,
                    label: user.email
                }));

                setAllUsers(formattedUsers);
            }
        } catch (error) {
            console.error("Error fetching user list:", error);
        }
    };


    const MappingList = async () => {
        let paramData = {
            user_id: userId,
            token: userToken,
            method: "entity_mgnt_list"
        }
        try {
            let { data } = await Axios.post(`${NODE_HOST_URL_v1}/entity_chain_management`, paramData)
            if (data.success) {
                let sortedData = data.data.sort((a, b) => new Date(b.created_date) - new Date(a.created_date));
                setChainDataList(sortedData)
            }
            else {
                setError({
                    status: true,
                    bgColor: "alert alert-danger",
                    errorMessage: data.message
                })
                setTimeout(() => {
                    setError({ status: false })
                }, 3000);
            }
        } catch (error) {
            setError({
                status: true,
                bgColor: "alert alert-danger",
                errorMessage: error.message
            })
            setTimeout(() => {
                setError({ status: false })
            }, 3000);
        }
    }

    const handleUserChanges = (selectedOption) => {
        setSelectedUser(selectedOption)
        setError({ status: false });
        setDataItem({ ...dataItem, chainUsers: selectedOption.label })
    }

    const handleChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value })
        setError({ status: false });
    }

    const handleEntityID = (e) => {
        setEntityID(e.target.value)
        setError({ status: false });
        setDataItem({ ...dataItem, chainValues: e.target.value })
    }

    const isValid = () => {
        if (selectedUser === undefined || selectedUser === '') {
            setError({
                status: true,
                bgColor: "alert alert-danger",
                errorMessage: "Please Select the User"
            });
            return false
        }
        if (entityId === undefined || entityId === '') {
            setError({
                status: true,
                bgColor: "alert alert-danger",
                errorMessage: "Please Enter EntityID"
            })
            return false
        }
        if (dataItem.deliverFunctions === undefined || dataItem.deliverFunctions === '') {
            setError({
                status: true,
                bgColor: "alert alert-danger",
                errorMessage: "Please Enter Delivery Function"
            })
            return false
        }
        if (dataItem.chainUsers === undefined || dataItem.chainUsers === '') {
            setError({
                status: true,
                bgColor: "alert alert-danger",
                errorMessage: "Please Enter Chain Users"
            })
            return false
        }
        if (dataItem.chainValues === undefined || dataItem.chainValues === '') {
            setError({
                status: true,
                bgColor: "alert alert-danger",
                errorMessage: "Please Enter Chain Values"
            })
            return false
        }
        else {
            return true
        }
    }

    const SaveMapping = async () => {
        if (isValid()) {
            let paramData = {
                user_id: userId,
                token: userToken,
                method: "entity_mgnt_create",
                entity_id: entityId,
                username: selectedUser.label,
                id: selectedUser.value,
                chain_users: dataItem.chainUsers,
                chain_values: dataItem.chainValues,
                delivery_function: dataItem.deliverFunctions
            }
            try {
                let { data } = await Axios.post(`${NODE_HOST_URL_v1}/entity_chain_management`, paramData)
                if (data.success) {
                    setError({
                        status: true,
                        bgColor: "alert alert-success",
                        errorMessage: data.message
                    })
                    setTimeout(() => {
                        setError({ status: false })
                    }, 3000);
                    setSelectedUser('')
                    setDataItem({
                        deliverFunctions: '',
                        chainUsers: '',
                        chainValues: ''
                    });
                    setEntityID('')
                    MappingList();
                }
                else {
                    setError({
                        status: true,
                        bgColor: "alert alert-danger",
                        errorMessage: data.message
                    })
                    setTimeout(() => {
                        setError({ status: false })
                    }, 3000);
                }
            } catch (error) {
                setError({
                    status: true,
                    bgColor: "alert alert-danger",
                    errorMessage: error.message
                })
                setTimeout(() => {
                    setError({ status: false })
                }, 3000);
            }
        }
    }

    const EditData = (userid, username, entityId, chainUsers, chainValues, deliverFunctions) => {
        setSelectedUser({ value: userid, label: username })
        setEntityID(entityId)
        setDataItem({
            deliverFunctions: deliverFunctions,
            chainUsers: chainUsers,
            chainValues: chainValues
        })
        setUsersId(userid)
    }

    const UpdateData = async () => {
        if (isValid()) {
            let paramData = {
                user_id: userId,
                token: userToken,
                method: "entity_mgnt_update",
                id: selectedUser.value,
                chain_users: dataItem.chainUsers,
                chain_values: dataItem.chainValues,
                delivery_function: dataItem.deliverFunctions
            };
            try {
                let { data } = await Axios.post(`${NODE_HOST_URL_v1}/entity_chain_management`, paramData)
                if (data.success) {
                    setError({
                        status: true,
                        bgColor: "alert alert-success",
                        errorMessage: data.message
                    })
                    setTimeout(() => {
                        setError({ status: false })
                    }, 3000);
                    setSelectedUser('')
                    setDataItem({
                        deliverFunctions: '',
                        chainUsers: '',
                        chainValues: ''
                    })
                    setEntityID('')
                    MappingList();
                }
                else {
                    setError({
                        status: true,
                        bgColor: "alert alert-danger",
                        errorMessage: data.message
                    })
                    setTimeout(() => {
                        setError({ status: false })
                    }, 3000);
                }
            } catch (error) {
                setError({
                    status: true,
                    bgColor: "alert alert-danger",
                    errorMessage: error.message
                })
                setTimeout(() => {
                    setError({ status: false })
                }, 3000);
            }
        }
    };

    const Delete = (id, entity_id) => {
        setDeleteModal(true);
        setChainid(id);
        setChainEntityid(entity_id)
    }

    const ClosePopup = () => {
        setDeleteModal(false);
        setChainid("");
        setChainEntityid("")
    }

    const DeleteMapping = async () => {
        let paramData = {
            user_id: userId,
            token: userToken,
            method: "entity_mgnt_delete",
            id: chainid,
            entity_id: chainentityid
        }
        try {
            let { data } = await Axios.post(`${NODE_HOST_URL_v1}/entity_chain_management`, paramData)
            if (data.success) {
                setError({
                    status: true,
                    bgColor: "alert alert-success",
                    errorMessage: data.message
                })
                setTimeout(() => {
                    setError({ status: false })
                }, 3000);
                MappingList();
                ClosePopup();
            }
            else {
                setError({
                    status: true,
                    bgColor: "alert alert-danger",
                    errorMessage: data.message
                })
                setTimeout(() => {
                    setError({ status: false })
                }, 3000);
            }
        } catch (error) {
            setError({
                status: true,
                bgColor: "alert alert-danger",
                errorMessage: error.message
            })
            setTimeout(() => {
                setError({ status: false })
            }, 3000);
        }
    }

    const handleStaus = async (userid, status) => {
        let paramData = {
            user_id: userId,
            token: userToken,
            method: "entity_mgnt_status",
            id: userid,
            status: status === 1 ? "no" : "yes"
        }
        try {
            let { data } = await Axios.post(`${NODE_HOST_URL_v1}/entity_chain_management`, paramData)
            if (data.success) {
                setError({
                    status: true,
                    bgColor: "alert alert-success",
                    errorMessage: data.message
                })
                setTimeout(() => {
                    setError({ status: false })
                }, 3000);
                MappingList();
            }
            else {
                setError({
                    status: true,
                    bgColor: "alert alert-danger",
                    errorMessage: data.message
                })
                setTimeout(() => {
                    setError({ status: false })
                }, 3000);
            }
        } catch (error) {
            setError({
                status: true,
                bgColor: "alert alert-danger",
                errorMessage: error.message
            })
            setTimeout(() => {
                setError({ status: false })
            }, 3000);
        }
    }

    return (
        <div>
            <div className="wrapper">
                <AdminLeftMenu />
                <div className="main">
                    <AdminHeader />
                    <main className="content">
                        <div className="card">
                            <div className="card-body">
                                <div className="container-fluid p-0">
                                    <div className="">
                                        <div className="row">
                                            <div className="col-md-12">

                                                {
                                                    error.status ?
                                                        <div className={error.bgColor} role="alert">
                                                            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                                {/* <span aria-hidden="true">×</span> */}
                                                            </button>
                                                            <div className="">
                                                                {error.errorMessage}
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }


                                                <h5 className="card-title"><FontAwesomeIcon className='mr-2' icon={faPaperPlane} />Create Entity Chain Mapping</h5>

                                                <hr />

                                                <div className="">
                                                    <div className='row'>
                                                        <div className='col-4'>
                                                            <label>Users</label><span style={{ color: "red" }}>*</span>
                                                            <Select
                                                                onChange={handleUserChanges}
                                                                options={allUsers}
                                                                value={selectedUser}
                                                                isSearchable={true}
                                                                placeholder="All Users"
                                                                styles={customStyles}
                                                                isDisabled={usersId ? true : false}
                                                            />
                                                        </div>

                                                        <div className='col-4'>
                                                            <label>Entity ID</label><span style={{ color: "red" }}>*</span>
                                                            <input type='text' disabled={usersId ? true : false} className='form-control' name='entityId' value={entityId} onChange={handleEntityID} placeholder='Enter Entity ID' />
                                                        </div>

                                                        <div className='col-4'>
                                                            <label>Delivery Function TMID(TMDF1)</label><span style={{ color: "red" }}>*</span>
                                                            <input type='text' className='form-control' name='deliverFunctions' value={dataItem.deliverFunctions} onChange={handleChange} placeholder='Enter Delivery Function (TMID)' />
                                                        </div>
                                                    </div>

                                                    <div className='row'>
                                                        <div className='col-6'>
                                                            <label>Chain Users</label><span style={{ color: "red" }}>*</span>
                                                            <textarea className='form-control' name='chainUsers' value={dataItem.chainUsers} onChange={handleChange} placeholder='promotion2@authkey.io , promotion2@authkey.io' />
                                                        </div>

                                                        <div className='col-6'>
                                                            <label>Chain Values</label><span style={{ color: "red" }}>*</span>
                                                            <textarea className='form-control' name='chainValues' value={dataItem.chainValues} onChange={handleChange} placeholder='1111,2222' />
                                                        </div>
                                                    </div>

                                                    <div className='row'>
                                                        <div className='col-6'></div>
                                                        <div className='col-6'>
                                                            {usersId ? <button type="button" onClick={UpdateData} className="btn btn-info float-right mt-2">Update Mapping</button> : <button type="button" onClick={SaveMapping} className="btn btn-info float-right mt-2">Save Mapping</button>}
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <div className="container-fluid p-0">
                                    <div className="">
                                        <div className="row">
                                            <div className="col-md-12">

                                                <div className='row'>
                                                    <div className='col-8'>
                                                        <h5 className="card-title"><FontAwesomeIcon className='mr-2' icon={faPaperPlane} />Entity Chain Mapping List</h5>
                                                    </div>

                                                    <div className='col-4'>
                                                        <input type='text' className='form-control' value={searchList} onChange={(e) => setSearchList(e.target.value)} placeholder='Enter to Search' />
                                                    </div>
                                                </div>

                                                <hr />

                                                <div className="">
                                                    <div className="table-responsive">
                                                        <table className="table table-striped table-bordered">
                                                            <thead className="table-dark">
                                                                <tr>
                                                                    <th>User ID</th>
                                                                    <th>Entity ID</th>
                                                                    <th>Chain Users</th>
                                                                    <th>Chain Values</th>
                                                                    <th>TMDF1</th>
                                                                    <th>Submitted On</th>
                                                                    <th>Chain Status</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {chainDataList.filter((x) => {
                                                                    return searchList.toLowerCase() === '' ? x : x.chain_users.toLowerCase().includes(searchList)
                                                                }).map((user) => (
                                                                    <tr>
                                                                        <td>{user.user_id}</td>
                                                                        <td>{user.entity_id}</td>
                                                                        <td>{user.chain_users}</td>
                                                                        <td>{user.chain_values}</td>
                                                                        <td>{user.tmdf1}</td>
                                                                        <td>{user.created_date}</td>
                                                                        <td>{user.status === 1 ? 'YES' : 'NO'}</td>
                                                                        <td>
                                                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                                                <div
                                                                                    style={{
                                                                                        width: "10px",
                                                                                        height: "10px",
                                                                                        borderRadius: "50%",
                                                                                        backgroundColor: user.status === 1 ? "#187C19" : "#ff0000",
                                                                                        marginRight: "10px",
                                                                                        cursor: "pointer"
                                                                                    }}
                                                                                    onClick={() => handleStaus(user.user_id, user.status)}
                                                                                ></div>

                                                                                <FontAwesomeIcon
                                                                                    style={{ cursor: "pointer", marginRight: "10px" }}
                                                                                    onClick={() =>
                                                                                        EditData(
                                                                                            user.user_id,
                                                                                            user.username,
                                                                                            user.entity_id,
                                                                                            user.chain_users,
                                                                                            user.chain_values,
                                                                                            user.tmdf1
                                                                                        )
                                                                                    }
                                                                                    icon={faEdit}
                                                                                />

                                                                                <FontAwesomeIcon
                                                                                    style={{ cursor: "pointer", color: "red" }}
                                                                                    onClick={() => Delete(user.user_id, user.entity_id)}
                                                                                    icon={faTrashAlt}
                                                                                />
                                                                            </div>
                                                                        </td>


                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <DeleteModal show={deleteModal} onClose={ClosePopup} onDelete={DeleteMapping} />
                    </main>
                    <AdminFooter />
                </div>
            </div>
        </div>
    )
}

export default EntityChainManagement
